import './app.css'
import Router from 'svelte-spa-router'
import { routes } from './lib/router'

const app = new Router({
  target: document.getElementById('app')!,
  props: {
    routes
  }
})

export default app